import GlobalVariable from '@/global/global-variable'

// 查询报警类型
const searchAlarmTypeApi = GlobalVariable.BASE_PATH + "/rest/tag/in/alarm/searchType";
const alarmStatisticsApi = GlobalVariable.BASE_PATH + "/rest/alarm/statisticsAlarm";

export default {
    // 查询报警类型
    searchAlarmTypeApi,
    // 查询报警数量
    alarmStatisticsApi
}



// WEBPACK FOOTER //
// ./src/request/api-alarm.js